import { Component, OnInit } from '@angular/core';
import {
	Data, DataLoaderService, CommonDataService, Subscription, AlternateOptionsService,
	PriceCalculationService, ProgressBarService, SummaryService, SortingService
} from '../service-call-index';
import { SummaryValidationComponent } from './../summary-validations/summary-validations.component';
import { AlternateScreenComponent } from '../../alternate-options/alternate-options.component';
import { Utils } from '../../../../shared/utils';
import { VehicleInfoService } from '../../../../services/vehicle-info.service';
@Component({
	selector: 'trim-options',
	templateUrl: './trim.template.html',
	styleUrls: ['./trim.component.css'],
})
export class TrimOptions implements OnInit {
	public trimOptions: Data[];
	public saved: Data[];
	private flag: boolean = false;
	public toggleContViewTrim: boolean = false;
	public currency: string;
	private subscription: Subscription;
	private selectedTrimOptions: Data[] = [];
	public trimSuggList = [];
	public errMessage;
	public lengthOfTrim: number;
	public vehicleInfo: any;
	public noLocalOptions: boolean;

	constructor(private dataLoaderService: DataLoaderService, private commonDataService: CommonDataService, private sortingService: SortingService,
		private summaryService: SummaryService, private priceCalculationService: PriceCalculationService,
		private progressService: ProgressBarService, private alternateOptionsService: AlternateOptionsService,
		private alternateScreenComponent: AlternateScreenComponent, private vehicleInfoService: VehicleInfoService,
		private summaryValidationComponent: SummaryValidationComponent) {
		this.vehicleInfo = this.vehicleInfoService.extractData();
		this.currency = this.dataLoaderService.data.currencyType;
		this.trimOptions = this.dataLoaderService.data.trim;
	}
	ngOnInit() {
		this.summaryService.getSelectedOptions();

		this.progressService.progressBarValidation();
		if (this.commonDataService.trimFlag) {
			this.toggleContViewTrim = true;
		}

		//fetching length for displaying in HTML
		this.lengthOfTrim = this.dataLoaderService.data.trim.length;

		//On load	
		let trim;
		this.trimOptions.forEach(element => {
			if (element.selected === true) {
				trim = element;
				this.saved = trim;
				this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalTrim", data: [trim] });
			}
		});
	}
	/**
	 * To select a trim option and send the selected option to the Summary screen
	 * @param item of Data type
	 * @returns none
	 */

	selectTrim(item) {
			setTimeout(() => {
				this.progressService.illuminateRed();
			}, 0);
	
		this.dataLoaderService.flagDictionary.loadingFlag = true;
		this.dataLoaderService.flagDictionary.resetTrimFlag = false;
		this.progressService.illuminateYellow();
		this.dataLoaderService.flagDictionary.alternateOverlayFlag = true;

		let index: number = -1;
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			let returnAlternateValues = this.alternateOptionsService.getAlternateOptionsNormal(item);
			returnAlternateValues.subscribe(
				alternateResponse => {
					if (alternateResponse.suggestions[0].addedCodes.length > 0 || alternateResponse.suggestions[0].removedCodes.length > 0) {
						this.trimSuggList = alternateResponse.suggestions;
						this.commonDataService.sendSuggestion(this.trimSuggList);
						this.openAlternateScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
					else {
						for (let i in this.trimOptions) {
							if (this.trimOptions[i].code === item.code) {
								this.trimOptions[i].selected = true;
								this.alternateScreenComponent.updatedPrices();
							} else {
								this.trimOptions[i].selected = false;
								//Updated prices from validation response
								for (let s in this.dataLoaderService.gccUpdatedPrices) {
									for(let k in this.trimOptions){
										if (this.trimOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code && this.trimOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType) {
											this.trimOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;}
									}
								}
							}
						
						}
						this.flag = this.itemCheck(item);
						if (this.flag) {
							this.saved = item;
						}
						this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
						this.dataLoaderService.flagDictionary.loadingFlag = false;
						if(this.commonDataService.progressBarNewOrderColorFlag == true && this.commonDataService.progressBarNewOrderUpholsteryFlag == true){
							setTimeout(() => {
								this.progressService.illuminateGreen();
							}, 0);
						}
						this.saveTrim();
					}
					this.sortingService.sortCodes(this.trimOptions,true)
				},
				err => {
					if (err._body !== undefined) {
						this.errMessage = err._body;
						this.commonDataService.notifyErrorMsgItem(this.errMessage);
						this.openAlternateErrorScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
				}
			);
		} else {
			for (let i in this.trimOptions) {
				if (this.trimOptions[i].code === item.code) {
					this.trimOptions[i].selected = true;
				} else {
					this.trimOptions[i].selected = false;
				}
			}
			this.flag = this.itemCheck(item);
			if (this.flag) {
				this.saved = item;
			}
			this.dataLoaderService.flagDictionary.validated = false;
			this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
			this.dataLoaderService.flagDictionary.loadingFlag = false;
			this.sortingService.sortCodes(this.trimOptions,true)
			this.saveTrim();
		}

		this.progressService.progressBarValidation();
	}

	itemCheck(item): boolean {
		let index: number = -1;
		if (this.saved !== undefined) {
			for (let j in this.trimOptions) {
				if (item.code === this.trimOptions[j].code && item === this.saved) {
					this.trimOptions[j].selected = false;
					this.flag = false;
					this.saved = undefined;
					return this.flag;
				}
			}
		}
		this.flag = true;
		return this.flag;
	}
	/**
	 * To go to the next Tab: Factory Options tab when clicked on the Continue button
	 * @param none
	 * @returns none
	 */
	gotoNextTab() {
		if(this.isMarketCA_N()||this.isMarketCA_T()){		
			this.dataLoaderService.flagDictionary.modeFlag = 'normal';
			if (!this.dataLoaderService.flagDictionary.noLocalOptions) {
				this.commonDataService.notifyOther({ option: 'activeLocal' });
			}	
		}
		else{
			if(this.isMarketEG()){
				if(this.checkForEGFacOptions()){
					if(this.checkForEGLocalOptions()){
						if(this.checkForEGPkgOptions()){
							// this.lastComponent = true;
						}
					} 
					else {
						this.commonDataService.notifyOther({ option: 'activePackage' });
					}
				}
				else{
					this.commonDataService.notifyOther({ option: 'activeLocal' });
				}
			}
			else{
				this.commonDataService.notifyOther({ option: 'activeFactory' });
			}			
		}
	}
	saveTrim() {
		if (this.saved !== undefined) {
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalTrim", data: [this.saved] });
			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertTrim", data: [this.saved] });
			this.priceCalculationService.normalModePriceCalculation();
		}
		else if (this.flag == false && this.saved == undefined) {
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalTrim", data: [] });
			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertTrim", data: [] });
			this.priceCalculationService.normalModePriceCalculation();
		}
		this.progressService.progressBarValidation();
	}
	openAlternateScreen() {
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			this.dataLoaderService.flagDictionary.alternateErrorFlag = false;
			this.dataLoaderService.flagDictionary.alternateValidateFlag = true;
			this.progressService.illuminateRed();
		}
	}
	openAlternateErrorScreen() {
		this.dataLoaderService.flagDictionary.alternateErrorFlag = true;
		this.dataLoaderService.flagDictionary.alternateValidateFlag = false;
		this.progressService.illuminateRed();
	}
	validate() {
		this.summaryValidationComponent.alternateOptionsForURLFlag2Validate();
	}
	isMarketCA_N(){
		return Utils.isCountryCA_N(this.vehicleInfo.orderingMarket);
	}
	
	isMarketCA_T(){
		return Utils.isCountryCA_T(this.vehicleInfo.orderingMarket);
	}
	isMarketEG(){
		return Utils.isCountryEG(this.vehicleInfo.orderingMarket);
	}
	checkForCALocalOptions(){
		if(this.isMarketCA_N() || this.isMarketCA_T()){
			if(this.dataLoaderService.data.options.length>0){
				return false;
			}
			else {
				return true;
			}
		}
	}

	public facOptions: boolean;
	public locOptions: boolean;
	public pkgOptions: boolean;

	checkForEGFacOptions(){
		if(this.isMarketEG()){
			if(this.dataLoaderService.data.facOptions.length>0){
				return false;
			}
			else{
				this.facOptions = true;
				return true;
			}
		}
	}
	checkForEGLocalOptions(){
		if(this.isMarketEG()){
			if(this.dataLoaderService.data.options.length>0){
				return false;
			}
			else{
				this.locOptions = true;
				return true;
			}
		}
	}
	checkForEGPkgOptions(){
		if(this.isMarketEG()){
			if((this.dataLoaderService.data.localPackagesList.length>0)&&(this.dataLoaderService.data.packages.length>0)){
				return false;
			}
			else{
				this.pkgOptions = true;
				return true;
			}
		}
	}	
}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/normal-screen-components/trim/trim.component.ts